<div class="box-popup relative">
    <ng-container [ngSwitch]="step">
        <app-byoc-mission-step-general *ngSwitchCase="'general'"></app-byoc-mission-step-general>
        <app-byoc-mission-step-course *ngSwitchCase="'course'"></app-byoc-mission-step-course>
        <app-byoc-mission-step-position *ngSwitchCase="'position'"></app-byoc-mission-step-position>
    </ng-container>
    <app-loader *ngIf="processing" loaderType="cover" overlayColor="white"></app-loader>
</div>
